import CryptoJS from "crypto-js";
import moment from "moment";
import { formatValue } from "react-currency-input-field";
import * as appConstants from "../Constants/appConstants";
import { CONFIGS, MODULES } from "../Constants/appConstants";
import INDIAN_STATES from "../Constants/indianStates.json";
import * as storageConstants from "../Constants/storageConstant";
import { CONFIG } from "../Constants/storageConstant";
import { BROWSER_STORAGE_ERROR } from "../Constants/stringConstants";
import { isTodayDate } from "../Utils/dateUtils";
import canAccessModule from "../Utils/permissionUtils";
export { canAccessModule, MODULES };
import { isNullOrEmpty } from "../Utils/stringUtils";
import { warn } from "../Wrapper/toast/toast";
import * as apiHelper from "./ApiHelper";
const localStorageArray = [
  storageConstants.AUTH,
  storageConstants.MASTER_DATA,
  storageConstants.SYSTEM_DATA,
  storageConstants.PERMISSIONS,
  storageConstants.DATES,
  storageConstants.CONFIG,
  storageConstants.INVESTIGATION,
  storageConstants.PRESCRIPTION_DOCTORS,
  storageConstants.USER_DATA,
  storageConstants.HOSPITAL_DATA,
  storageConstants.HOSPITAL_NOTIFICATION_CHANNELS,
  storageConstants.PATIENT_SEARCH_QUERIES,
  storageConstants.LAST_VISITED_PAGE,
  storageConstants.LAST_VISITED_PATIENT_PAGE,
  storageConstants.SELECTED_ROW,
  storageConstants.NOTES_SUGGESTION,
  storageConstants.COUNSELLING_NOTES_SUGGESTION,
  storageConstants.COUNSELLING_REMARKS_SUGGESTION,
];

const sessionStorageArray = [];

let systemDataCache = {
  medicines: null,
  doctors: null,
  departments: null,
  suppliers: null,
  services: null,
  service_type: null,
  product_type: null,
  inventory_category: null,
  custom_billing_item: null,
  medicine_companies: null,
};

const getEntityMap = (entity) => {
  if (systemDataCache[entity]) return systemDataCache[entity];

  const data = getLocalData(storageConstants.SYSTEM_DATA);
  if (data?.[entity] && Array.isArray(data[entity])) {
    systemDataCache[entity] = new Map(data[entity].map((item) => [parseInt(item.id), item]));
  }
  return systemDataCache[entity];
};

const secretKey = process.env.REACT_APP_NAME || "BharatOPD";

function encryptData(data) {
  return CryptoJS.AES.encrypt(
    typeof data === "string" ? data : JSON.stringify(data),
    secretKey,
  ).toString();
}

function decryptData(encryptedData) {
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

  try {
    return JSON.parse(decryptedText);
  } catch (e) {
    return decryptedText;
  }
}

export function getLocalData(name) {
  try {
    let storedData = null;

    if (sessionStorageArray.includes(name)) {
      storedData = sessionStorage.getItem(name);
    } else if (localStorageArray.includes(name)) {
      storedData = localStorage.getItem(name);
    }

    if (!storedData) {
      if (name === storageConstants.CONFIG || name === CONFIG) {
        return [];
      }
      return null;
    }

    const decrypted = decryptData(storedData);
    if (name === storageConstants.CONFIG || name === CONFIG) {
      if (Array.isArray(decrypted)) {
        return decrypted;
      }
      if (decrypted && typeof decrypted === "object") {
        return Object.entries(decrypted).map(([key, item]) => {
          if (item && typeof item === "object" && !Array.isArray(item)) {
            return {
              key: item.key || key,
              name: item.name || key,
              value: item.value !== undefined ? item.value : item,
              show: item.show !== undefined ? String(item.show) : "true",
              mandatory: item.mandatory !== undefined ? String(item.mandatory) : "false",
              ...item,
            };
          }
          return {
            key,
            name: key,
            value: item,
            show: "true",
            mandatory: "false",
          };
        });
      }
      return [];
    }

    return decrypted;
  } catch (e) {
    console.error("Decryption error:", e);
    if (name === storageConstants.CONFIG || name === CONFIG) {
      return [];
    }
    return null;
  }
}

export function storeLocalData(name, data) {
  try {
    let dataToStore = data;
    if (name === storageConstants.CONFIG || name === CONFIG) {
      if (Array.isArray(data)) {
        dataToStore = data;
      } else if (data && typeof data === "object") {
        dataToStore = Object.entries(data).map(([key, item]) => {
          if (item && typeof item === "object" && !Array.isArray(item)) {
            return {
              key: item.key || key,
              name: item.name || key,
              value: item.value !== undefined ? item.value : item,
              show: item.show !== undefined ? String(item.show) : "true",
              mandatory: item.mandatory !== undefined ? String(item.mandatory) : "false",
              ...item,
            };
          }
          return {
            key,
            name: key,
            value: item,
            show: "true",
            mandatory: "false",
          };
        });
      } else {
        dataToStore = [];
      }
    }

    const encryptedData = encryptData(dataToStore);

    if (sessionStorageArray.includes(name)) {
      sessionStorage.setItem(name, encryptedData);
    } else if (localStorageArray.includes(name)) {
      localStorage.setItem(name, encryptedData);
    }

    return true;
  } catch (e) {
    swal({
      title: "Warning",
      text: "Your web browser does not support storing settings locally. Some settings may not save or some features may not work properly for you.",
      icon: "warning",
    });
    console.error("Encryption error:", e);
    return false;
  }
}

import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

export function swal(optionsOrTitle, textParam, iconParam) {
  let options = {};
  if (typeof optionsOrTitle === "string") {
    options = {
      title: optionsOrTitle,
      text: textParam || "",
      icon: iconParam || "info",
    };
  } else {
    options = optionsOrTitle || {};
  }

  const isConfirmDialog =
    (Array.isArray(options.buttons) && options.buttons.length > 1) ||
    options.showCancelButton === true;

  const confirmText =
    options.confirmButtonText ||
    (Array.isArray(options.buttons) && options.buttons[1]) ||
    (typeof options.button === "string" ? options.button : isConfirmDialog ? "Yes" : "OK");

  const cancelText =
    options.cancelButtonText || (Array.isArray(options.buttons) && options.buttons[0]) || "No";
  const { buttons: _b, dangerMode: _d, button: _btn, ...swalFireOptions } = options;

  const swalConfig = {
    title: options.title || (isConfirmDialog ? "Are you sure?" : "Notification"),
    text: options.text || "",
    icon: options.icon || "info",
    showCancelButton: isConfirmDialog,
    confirmButtonText: confirmText,
    buttonsStyling: false,
    customClass: {
      confirmButton: `btn ${options.dangerMode ? "swal2-danger" : "btn-primary"}`,
    },
    ...swalFireOptions,
  };

  if (isConfirmDialog) {
    swalConfig.cancelButtonText = cancelText;
    swalConfig.customClass.cancelButton = "btn swal2-cancel";
  }

  return Swal.fire(swalConfig).then((result) => {
    return result.isConfirmed;
  });
}

const darkenColor = (color, amount) => {
  let usePound = false;

  if (color[0] === "#") {
    color = color.slice(1);
    usePound = true;
  }

  const num = parseInt(color, 16);

  let r = (num >> 16) - amount;
  if (r < 0) r = 0;
  else if (r > 255) r = 255;

  let g = ((num >> 8) & 0x00ff) - amount;
  if (g < 0) g = 0;
  else if (g > 255) g = 255;

  let b = (num & 0x0000ff) - amount;
  if (b < 0) b = 0;
  else if (b > 255) b = 255;

  return (
    (usePound ? "#" : "") +
    r.toString(16).padStart(2, "0") +
    g.toString(16).padStart(2, "0") +
    b.toString(16).padStart(2, "0")
  );
};

export const setPrimarySecondaryColors = (color = "#14293f") => {
  // default primary
  const primaryColor = color;
  const secondaryColor = darkenColor(primaryColor, 20);

  document.documentElement.style.setProperty("--primary", primaryColor);
  document.documentElement.style.setProperty("--secondary", secondaryColor);
};

export function clearLocalStorageData() {
  try {
    localStorage.clear();
    // Clear system data cache
    Object.keys(systemDataCache).forEach((key) => (systemDataCache[key] = null));
    return true;
  } catch (e) {
    return false;
  }
}

export const getMasterData = () => {
  return getLocalData(storageConstants.MASTER_DATA);
};

export const getSystemData = async () => {
  return getLocalData(storageConstants.SYSTEM_DATA);
};

export function isEmailValid(email) {
  const regex =
    /^(([A-Za-z0-9](?!.*\.{2})[A-Za-z0-9_\-\.]+[A-Za-z0-9])|([A-Za-z0-9]{1,60}))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,15}|[0-9]{1,3})(\]?)$/; /* eslint-disable-line */
  return regex.test(email);
}

export const preventPlusMinusInNumberInput = (e) => {
  // Prevent entry of minus sign (keycode 189) and plus sign (keycode 187)
  if (e.keyCode === 189 || e.keyCode === 109 || e.keyCode === 187 || e.keyCode === 107) {
    e.preventDefault();
  }
};

export const getTwoDecimalPlaces = (num) => {
  const n = num?.toString();
  return n?.includes(".") ? n?.substring(0, n.indexOf(".") + 3) : n;
};

export const formattedValue = (val, prefix, allowDecimals = true) =>
  formatValue({
    value: `${val}`,
    groupSeparator: ",",
    decimalSeparator: ".",
    prefix: prefix ? "₹" : "",
    intlConfig: prefix ? { locale: "en-IN", currency: "INR" } : null,
    decimalScale: prefix || allowDecimals ? 2 : null,
  });
export const convertIntoPaise = (val) => {
  return val * 100;
};
export const convertIntoRupee = (val) => {
  if (val) {
    return val / 100;
  } else {
    return 0;
  }
};
export const formattedValueInInt = (val, prefix, allowDecimals = true) =>
  formatValue({
    value: `${val}`,
    groupSeparator: ",",
    decimalSeparator: ".",
    prefix: prefix ? "₹" : "",
    intlConfig: prefix ? { locale: "en-IN", currency: "INR" } : null,
    decimalScale: prefix || allowDecimals ? null : null,
  });
export const removeInActive = (data) => {
  let activeData = data?.filter(
    (i) =>
      i?.status !== undefined &&
      (i?.status === 1 || i?.status?.toString()?.toUpperCase() === appConstants.ACTIVE),
  );

  return activeData;
};

export function amountFormatter(amount, type = "int") {
  try {
    if (isNaN(amount)) return amount;
    let a = isNullOrEmpty(amount) ? (type === "int" ? 0 : 0.0) : amount;

    a = type === "int" ? parseInt(a) : parseFloat(a);

    return type === "float"
      ? a?.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : a?.toLocaleString("en-IN");
  } catch (e) {
    return amount;
  }
}

export function removeCommaFromAmount(amount, type = "int") {
  const a = isNullOrEmpty(amount) ? (type === "int" ? 0 : 0.0) : amount;
  const value = a?.toString().replace(/,/g, "");
  const v = getTwoDecimalPlaces(value);

  return type === "int" ? parseInt(v) : parseFloat(v);
}

export const fetchMasterData = async (setLoading) => {
  setLoading && setLoading(true);
  try {
    const response = await apiHelper.masterData();
    if (response?.isSuccess) {
      try {
        storeLocalData(storageConstants.MASTER_DATA, response?.data?.data);
      } catch (e) {
        warn(BROWSER_STORAGE_ERROR);
      }
    }
  } catch (_) {
    // Ignore error and unblock loader
  } finally {
    setLoading && setLoading(false);
  }
};

export const fetchSystemData = async (setLoading) => {
  setLoading && setLoading(true);
  try {
    const response = await apiHelper.systemData();
    if (response?.isSuccess) {
      try {
        storeLocalData(storageConstants.SYSTEM_DATA, response?.data);
        // Clear cache so it gets rebuilt with fresh data
        Object.keys(systemDataCache).forEach((key) => (systemDataCache[key] = null));
      } catch (e) {
        warn(BROWSER_STORAGE_ERROR);
      }
    }
  } catch (_) {
    // Ignore error and unblock loader
  } finally {
    setLoading && setLoading(false);
  }
};
export const getTemplatesOptions = () => {
  const data = [
    {
      label: "template_1",
      value: 1,
    },
    {
      label: "template_2",
      value: 2,
    },
    {
      label: "template_3",
      value: 3,
    },
    {
      label: "template_4",
      value: 4,
    },
    {
      label: "template_5",
      value: 5,
    },
  ];
  if (data) {
    return data;
  } else return [];
};
export const getTemplatesCategory = () => {
  const data = [
    {
      label: "MARKETING",
      value: "MARKETING",
    },
    {
      label: "Utility",
      value: "Utility",
    },
  ];
  if (data) {
    return data;
  } else return [];
};
export const getLanguage = () => {
  const data = [
    {
      label: "English",
      value: "en",
    },
    {
      label: "Hindi",
      value: "hi",
    },
    {
      label: "Punjabi",
      value: "pa",
    },
  ];
  if (data) {
    return data;
  } else return [];
};
export const getGenderOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.genders) {
    const keys = Object.keys(data?.genders);
    const values = Object.values(data?.genders);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};
export const getDoseOptions = () => {
  let dose = [
    { label: "Once a day[OD]", value: 1 },
    { label: "Twice a day[BD]", value: 2 },
    { label: "Thrice a day[TDS]", value: 3 },
    { label: "Four a day[QiD] ", value: 4 },
    { label: "Five times a day", value: 5 },
  ];
  return dose;
};
export const getTimingOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.dosage_timings && Array.isArray(data.dosage_timings)) {
    return data.dosage_timings;
  } else return [];
};
export const getDiagnosisOptions = (data) => {
  if (data) {
    return data?.map((k) => ({
      label: k?.name,
      value: k?.id,
      status: k?.status,
    }));
  } else return [];
};
export const getDepartmentOptions = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.departments) {
    return data?.departments?.map((d) => ({
      label: d.name,
      value: d.id,
      status: d.status,
      is_default: d.default === 1 || d.default === "1",
    }));
  } else return [];
};

export const getTeleconsultOptions = () => {
  return [
    {
      label: "No",
      value: 0,
    },
    {
      label: "Yes",
      value: 1,
    },
  ];
};

export const getAreaTypeOptions = () => [
  { label: "Rural", value: "rural" },
  { label: "Urban", value: "urban" },
];

export const getDepartmentName = (id) => {
  const map = getEntityMap("departments");
  if (id && map) {
    return map.get(parseInt(id))?.name || "";
  } else return "";
};

export const getTaxType = () => {
  const configs = getLocalData(CONFIG);
  if (Array.isArray(configs)) {
    return configs.find((c) => c.key === CONFIGS.TAX_TYPE)?.value || "REGISTERED";
  }
  return "REGISTERED";
};

export const getDoctorOptions = (departmentId) => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (Array.isArray(data?.doctors)) {
    return data?.doctors?.reduce((acc, curr) => {
      if (curr.status === "active") {
        if (
          !departmentId ||
          isNullOrEmpty(curr.department_id) ||
          parseInt(curr.department_id) === parseInt(departmentId)
        ) {
          acc.push({
            value: curr.id,
            label: curr.name,
            role: curr.role,
            department_id: curr.department_id ?? null,
            is_default: curr.default === 1 || curr.default === "1",
          });
        }
      }

      return acc;
    }, []);
  } else return [];
};

export const getCreditStatus = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (!Array.isArray(data?.creditStatuses) || data.creditStatuses.length === 0) {
    return [
      { value: "OPEN", label: "Open" },
      { value: "SETTLED", label: "Settled" },
    ];
  }

  return data.creditStatuses.map((curr) => ({
    value: curr.id,
    label: curr.name,
  }));
};

export const getDoctorName = (id) => {
  const map = getEntityMap("doctors");
  if (id && map) {
    return map.get(parseInt(id))?.name || "";
  } else return "";
};
export const ageInFormat = (date) => {
  if (!date || date === "-") return "-";
  let format = "yrs";
  const currentDate = new Date();
  const birthDate = new Date(date);

  if (isNaN(birthDate.getTime())) return "-";

  const diffInMilliseconds = currentDate - birthDate;

  const years = currentDate.getFullYear() - birthDate.getFullYear();
  const months = currentDate.getMonth() - birthDate.getMonth();
  const days = currentDate.getDate() - birthDate.getDate();

  let adjustedYears = years;
  let adjustedMonths = months;
  let adjustedDays = days;

  if (adjustedDays < 0) {
    adjustedMonths--;
    adjustedDays += new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
  }

  if (adjustedMonths < 0) {
    adjustedYears--;
    adjustedMonths += 12;
  }

  switch (format) {
    case "mon":
      if (adjustedYears <= 0) {
        return adjustedMonths;
      }
      return adjustedYears * 12 + adjustedMonths;
    case "days":
      return Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    case "yrs":
    default:
      return `${adjustedYears} Y `;
  }
};

export const getMedicineTypes = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.product_type) {
    return data?.product_type?.map((m) => ({
      value: m.id,
      label: m.name,
      status: m.status,
    }));
  } else return [];
};

export const getMedicineCategories = (returnOnlyValue = false) => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.medicine_category) {
    return returnOnlyValue
      ? data?.medicine_category?.map((m) => m.id)
      : data?.medicine_category?.map((m) => ({
          value: m.id,
          label: m.name,
          status: m.status,
        }));
  } else return [];
};

export const getInventoryCategories = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.inventory_category) {
    return data?.inventory_category?.map((m) => ({
      value: m.id,
      label: m.name,
      status: m.status,
    }));
  } else return [];
};

export const getInventoryCategoryById = (id) => {
  const map = getEntityMap("inventory_category");
  if (id && map) {
    return map.get(parseInt(id))?.name || "-";
  } else return "-";
};

export const getMedicine = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.medicines) {
    return data?.medicines?.map((m) => ({
      value: m.id,
      label: m.name,
    }));
  } else return [];
};

export const getMedicineTypeById = (id) => {
  const map = getEntityMap("product_type");
  if (id && map) {
    return map.get(parseInt(id))?.name || "";
  } else return "";
};

export const getMedicineOptions = (billable = true) => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);
  const configs = getLocalData(CONFIG);
  const show_medicine_type_val = Array.isArray(configs)
    ? configs?.find((c) => c.key === CONFIGS.SHOW_MEDICINE_TYPE)?.value
    : null;

  // Enabled by default (null or anything except No/false)
  const isShowMedicineType =
    show_medicine_type_val !== appConstants.NO &&
    show_medicine_type_val !== "false" &&
    show_medicine_type_val !== false;

  if (data?.medicines) {
    let medicines = data?.medicines || [];
    const [billPendingMedsEnabled] = isConfigEnable(CONFIGS.BILL_PENDING_MEDS);
    medicines = medicines.filter((m) => {
      const status = m?.status?.toString()?.toUpperCase();
      const isActive = status === appConstants.ACTIVE || status === "1";
      const isReviewPending = status === appConstants.REVIEW_PENDING;

      // Filter by status first
      if (!(isActive || (billPendingMedsEnabled && isReviewPending))) {
        return false;
      }

      // Then filter by billable if requested
      if (billable && m?.billable === 0) {
        return false;
      }

      return true;
    });

    const uniqueMedicines = [];
    const seenLabels = new Set();

    medicines.forEach((m) => {
      const typeName = m.type_name ? m.type_name + ". " : "";
      const label = isShowMedicineType ? typeName + m.name : m.name;
      if (!seenLabels.has(label)) {
        uniqueMedicines.push({
          value: m.id,
          label: label,
          description: [m?.description, m?.category_name].filter(Boolean).join(" - "),
        });
        seenLabels.add(label);
      }
    });

    return uniqueMedicines.sort((a, b) => a.label.localeCompare(b.label));
  } else return [];
};

export const getServiceOptions = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.services) {
    const activeServices = removeInActive(data.services);
    const uniqueServices = [];
    const seenIds = new Set();

    activeServices.forEach((s) => {
      if (s?.id && !seenIds.has(s.id)) {
        const label = s?.type ? `${s?.name} (${s?.type})` : s?.name;
        uniqueServices.push({
          value: s?.id,
          label: label,
          price: s?.price,
          description: s?.description || "",
          gender: s?.gender || "",
          status: s?.status,
        });
        seenIds.add(s.id);
      }
    });

    return uniqueServices;
  } else return [];
};

export const getCustomBillingItemOptions = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.custom_billing_item) {
    const activeItems = removeInActive(data.custom_billing_item);
    const uniqueItems = [];
    const seenIds = new Set();

    activeItems.forEach((s) => {
      if (s?.id && !seenIds.has(s.id)) {
        uniqueItems.push({
          value: s?.id,
          label: s?.name,
          price: s?.price,
          description: s?.description || "",
          default_qty: s?.default_qty || 1,
          status: s?.status,
        });
        seenIds.add(s.id);
      }
    });

    return uniqueItems;
  } else return [];
};

export const getServiceDetails = (id) => {
  const data = getServiceOptions();

  if (id && data) {
    const matchedResult = data?.filter((s) => s.value === parseInt(id));
    return matchedResult?.length > 0 ? matchedResult[0] : {};
  } else {
    return {};
  }
};

export const getServiceTypeOptions = (returnOnlyValue = false) => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.service_type) {
    return returnOnlyValue
      ? data?.service_type?.map((s) => s.id)
      : data?.service_type?.map((s) => ({
          value: s.id,
          label: s.name,
          status: s.status,
        }));
  } else return [];
};

export const getMedicineName = (id) => {
  const map = getEntityMap("medicines");
  if (id && map) {
    return map.get(parseInt(id))?.name || "";
  } else return "";
};

export const getMedicineById = (id) => {
  const map = getEntityMap("medicines");
  if (id && map) {
    return map.get(parseInt(id)) || null;
  } else return null;
};

export const getMedicineDesciption = (id) => {
  const map = getEntityMap("medicines");
  if (id && map) {
    return map.get(parseInt(id))?.description || "";
  } else return "";
};

export const getMedicinePackUnits = (id) => {
  const map = getEntityMap("medicines");
  if (id && map) {
    return map.get(parseInt(id))?.pack_units || 1;
  } else return 1;
};

export const getSupplierOptions = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.suppliers) {
    return data?.suppliers?.map((s) => ({
      value: s.id,
      label: s.name,
      status: s.status,
    }));
  } else return [];
};

export const getMedicineCompanyOptions = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.medicine_companies) {
    return data?.medicine_companies?.map((s) => ({
      value: s.id,
      label: s.name,
      status: s.status,
    }));
  } else return [];
};

export const getSupplierName = (id) => {
  const map = getEntityMap("suppliers");
  if (id && map) {
    return map.get(parseInt(id))?.name || "";
  } else return "";
};

export const getMedicineCompanyName = (id) => {
  const map = getEntityMap("medicine_companies");
  if (id && map) {
    return map.get(parseInt(id))?.name || "";
  } else return "";
};

export const getServiceName = (id) => {
  const map = getEntityMap("services");
  if (id && map) {
    return map.get(parseInt(id))?.name || "";
  } else return "";
};

export const getServiceTypeName = (id) => {
  const map = getEntityMap("service_type");
  if (id && map) {
    return map.get(parseInt(id))?.name || "";
  } else return "";
};

export const getSupplierAddress = (id) => {
  const map = getEntityMap("suppliers");
  if (id && map) {
    return map.get(parseInt(id))?.address || "";
  } else return "";
};

export const getPaymodeOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (!data?.payment_options) return [];

  return Object.entries(data.payment_options).map(([key, value]) => ({
    label: value,
    value: key,
  }));
};

export const getYesNoOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.yes_no) {
    const keys = Object.keys(data?.yes_no);
    const values = Object.values(data?.yes_no);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};

export const getHivScreeningOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.hiv_screening) {
    const keys = Object.keys(data?.hiv_screening);
    const values = Object.values(data?.hiv_screening);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};

export const getRouteOfAddmisionOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.route_of_admissions) {
    const keys = Object.keys(data?.route_of_admissions);
    const values = Object.values(data?.route_of_admissions);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};
export const getStiOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.sti_symptoms) {
    const keys = Object.keys(data?.sti_symptoms);
    const values = Object.values(data?.sti_symptoms);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};

export const getLivingOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.living_types) {
    const keys = Object.keys(data?.living_types);
    const values = Object.values(data?.living_types);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};

export const getEmploymentOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.employment_types) {
    const keys = Object.keys(data?.employment_types);
    const values = Object.values(data?.employment_types);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};

export const getEducationOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.education_types) {
    const keys = Object.keys(data?.education_types);
    const values = Object.values(data?.education_types);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};

export const getAgeGroupOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.age_groups) {
    const keys = Object.keys(data?.age_groups);
    const values = Object.values(data?.age_groups);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};

export const getMaritalStatusOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.marital_status) {
    const keys = Object.keys(data?.marital_status);
    const values = Object.values(data?.marital_status);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};

export const getDAMSOptions = () => {
  const data = [
    {
      id: 2374,
      name: "Alcohol",
    },
    {
      id: 2375,
      name: "Heroin (Smack, Brown Sugar, No. 4 etc)",
    },
    {
      id: 2376,
      name: "Opium (Opium, Doda etc.)",
    },
    {
      id: 2377,
      name: "Other Opioids (Norphim, Proxyvon, Parvon Forte, Parvon Plus Parvon, Parvon-N, Spasmo Proxyvon, Parvodex, Fortwin etc.)",
    },
    {
      id: 2378,
      name: "Cannabis (Ganja, Charas etc.)",
    },
    {
      id: 2379,
      name: "Sedatives/Hypnotics (e,g. Valium, Nitravet, Tablet No. 10)",
    },
    {
      id: 2380,
      name: "Cocaine",
    },
    {
      id: 2381,
      name: "Other Stimulats including Amphetamines",
    },
    {
      id: 2382,
      name: "Hallucinogens (LSD, PCP etc.)",
    },
    {
      id: 2383,
      name: "Tobacco",
    },
    {
      id: 2384,
      name: "Volatile Solvents",
    },
    {
      id: 2385,
      name: "Any Other (Specify)",
    },
  ];

  if (data) {
    return data?.map((d) => ({
      label: d.name,
      dam_id: d.id,
      value: d.id,
      everuse: true,
      currentuse: true,
    }));
  } else return [];
};
export const getPrescriptionApplicationOption = () => {
  const data = [
    {
      label: "FULL FACE",
      value: "FULL FACE",
    },
    {
      label: "LOCAL",
      value: "LOCAL",
    },
    {
      label: "SPOT",
      value: "SPOT",
    },
  ];

  return data;
};

export const splitBatchNumberForLabel = (batchNo) => {
  if (batchNo == null || batchNo === "") return "";
  const parts = String(batchNo)
    .replace(/undefined/g, "")
    .replace(/null/g, "")
    .split(/[ _]+/)
    .filter((s) => s !== "" && s !== "-" && s !== "_");

  return parts.join(" _ ");
};

// Stored batch keys look like "<batch> _ <purchase bill> _ <index>" (index only
// disambiguates the same batch across bills). Split for display; drop the index.
export const parseBatchNumber = (batchNo) => {
  if (batchNo == null || batchNo === "") return { batch: "", bill: "" };
  const parts = String(batchNo)
    .split(" _ ")
    .map((p) => p.trim())
    .filter((p) => p && p !== "undefined" && p !== "null");
  if (parts.length > 1 && /^\d+$/.test(parts[parts.length - 1])) parts.pop();
  return { batch: parts[0] || "", bill: parts.slice(1).join(" ") };
};

// "LC-8051E · Bill GST-46471" (or just the batch when there's no bill)
export const formatBatchLabel = (batchNo) => {
  const { batch, bill } = parseBatchNumber(batchNo);
  return bill ? `${batch} · Bill ${bill}` : batch;
};

export const getBatchNumberOptions = (arr) => {
  if (arr?.length > 0) {
    return arr?.map((d) => ({
      label: formatBatchLabel(d.batch_number),
      value: d.batch_number,
    }));
  } else return [];
};

export const getDiscountTypesOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.discount_types) {
    const keys = Object.keys(data?.discount_types);
    const values = Object.values(data?.discount_types);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};

export const getCityOptions = () => {
  const masterData = getLocalData(storageConstants.MASTER_DATA);

  if (masterData?.cities) {
    return masterData?.cities?.map((city) => ({
      label: `${city.name}, ${city.state}`,
      value: city.id,
    }));
  } else return [];
};

export const getCityName = (id) => {
  const masterData = getLocalData(storageConstants.MASTER_DATA);

  if (masterData?.cities) {
    const city = masterData?.cities.filter((city) => city.id === parseInt(id));
    return city?.length > 0 ? `${city[0].name}, ${city[0].state}` : "";
  } else return "";
};

export const getStateOptions = () => INDIAN_STATES;

export const getPatientStatusOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.patient_visit_status) {
    const keys = Object.keys(data?.patient_visit_status);
    const values = Object.values(data?.patient_visit_status);

    return keys?.map((k) => ({
      name: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};

export const getPatientStatusName = (key) => {
  if (key) {
    return getPatientStatusOptions()?.filter((s) => s.value === key)[0]?.name;
  } else {
    return "";
  }
};

export const getUserRoleOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.roles) {
    const keys = Object.keys(data?.roles);
    const values = Object.values(data?.roles);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};

export const getUserRoleName = (key) => {
  if (key) {
    return getUserRoleOptions()?.filter((s) => s.value === key)[0]?.label;
  } else {
    return "";
  }
};

export const getActiveInactiveOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.status) {
    const keys = Object.keys(data?.status);
    const values = Object.values(data?.status);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};
export const getRoomStatusOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.room_status) {
    const keys = Object.keys(data?.room_status);
    const values = Object.values(data?.room_status);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};

export const getPatientIdentifier = (id, data) => {
  const configData = getLocalData(CONFIG);

  const initialMap = {
    aadhar_no: false,
    mno: false,
    file_no: false,
    online_id: false,
    city: false,
    address: false,
  };

  if (!Array.isArray(configData)) return initialMap;

  configData.forEach((config) => {
    const isMandatory = config.mandatory === "true";
    const isShown = config.show === "true";

    if (!isMandatory || !isShown) return;

    switch (config.key) {
      case CONFIGS.AADHAR_NO:
        initialMap.aadhar_no = true;
        break;
      case "mobile_no":
        initialMap.mno = true;
        break;
      case CONFIGS.FILE_NO:
        initialMap.file_no = true;
        break;
      case CONFIGS.ONLINE_ID:
        initialMap.online_id = true;
        break;
      case CONFIGS.ADDRESS:
        initialMap.address = true;
        break;
      case CONFIGS.CITY:
        initialMap.city = true;
        break;
      default:
        break;
    }
  });

  let uid = data.uid !== undefined ? data.uid : (data?.patient?.uid ?? "-");
  if (initialMap?.file_no) {
    return `${data.file_no || data?.patient?.file_no || "-"}`;
  }

  if (initialMap?.aadhar_no) {
    return `${data.aadhar_no || data?.patient?.aadhar_no || "-"}`;
  }

  if (initialMap?.mno) {
    return `${data.mno || data?.patient?.mno || "-"}`;
  }

  if (initialMap?.online_id) {
    return `${data.online_id || data?.patient?.online_id || "-"}`;
  }
};

export const getNotifyType = () => {
  const data = [
    {
      value: "CUSTOM_USERS",
      label: "CUSTOM USERS",
    },
    {
      value: "HOSPITAL_USERS",
      label: "HOSPITAL USERS",
    },
  ];
  return data;
};
export const getAlertType = () => {
  const data = [
    {
      value: "CUSTOM",
      label: "CUSTOM",
    },
    {
      value: "ALL",
      label: "ALL",
    },
  ];
  return data;
};
export const getType = () => {
  const data = [
    {
      value: "STOCK",
      label: "STOCK",
    },
    {
      value: "EXPIRY",
      label: "BEFORE DAYS",
    },
  ];
  return data;
};
export const getOxygenOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.bed_oxygen) {
    const keys = Object.keys(data?.bed_oxygen);
    const values = Object.values(data?.bed_oxygen);

    let oxygenOptions = keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: parseInt(k),
    }));
    return oxygenOptions;
  } else return [];
};
export const getVaccumOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.bed_vaccum) {
    const keys = Object.keys(data?.bed_vaccum);
    const values = Object.values(data?.bed_vaccum);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: parseInt(k),
    }));
  } else return [];
};
export const getAttachedBathptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.bed_atch_bath) {
    const keys = Object.keys(data?.bed_atch_bath);
    const values = Object.values(data?.bed_atch_bath);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: parseInt(k),
    }));
  } else return [];
};
export const getStatusOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.bed_status) {
    const keys = Object.keys(data?.bed_status);
    const values = Object.values(data?.bed_status);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k.toString(),
    }));
  } else return [];
};
export const getBedOptions = () => {
  const data = getLocalData(storageConstants.MASTER_DATA);

  if (data?.bed_status) {
    const keys = Object.keys(data?.bed_status);
    const values = Object.values(data?.bed_status);

    return keys?.map((k) => ({
      label: values[keys.indexOf(k)],
      value: k,
    }));
  } else return [];
};

export const removeIfInActive = (list = [], id) => {
  // Filter active items

  // Find the assigned item (even if inactive)
  if (list?.length > 0) {
    const assignedItem = list.filter(
      (item) => item.value === id && (item.status === appConstants.INACTIVE || item.status === 0),
    );

    return assignedItem?.length > 0 ? true : false;
  }
};

export const getModuleOptions = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);
  if (data?.permissions) {
    return data?.permissions?.map((p) => ({
      label: p?.module,
      value: p?.id,
      name: p?.name,
    }));
  } else return [];
};

export const getReportOptions = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.report_type) {
    return data?.report_type?.map((r) => ({
      label: r?.value,
      value: r?.id,
    }));
  } else return [];
};

export const getInvestigationList = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.investigation) {
    return data?.investigation?.map((iv) => ({
      label: iv?.value,
      value: iv?.id,
    }));
  } else return [];
};
export const getApplicationList = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.application) {
    return data.application
      .filter((app) => app.status === "ACTIVE") // Only keep active applications
      .map((app) => ({
        label: app.name, // Assuming you want to display the name
        value: app.name,
        status: app.status,
      }));
  }

  return [];
};

export const getTherapistList = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.therapist) {
    return data?.therapist?.map((iv) => ({
      label: iv?.name,
      value: iv?.id,
      status: iv?.status,
    }));
  } else return [];
};
export const getInvestigationName = (id) => {
  const data = getInvestigationList();

  if (data.length && id) {
    return data.find((iv) => iv.value === parseInt(id))?.label;
  } else return "";
};

export const getInvoiceCopiesOptions = () => {
  return [
    { label: "1 Copy", value: 0 },
    { label: "2 Copies", value: 1 },
    { label: "3 Copies", value: 2 },
  ];
};

export const getNotificationChannelPartners = () => {
  const data = getLocalData(storageConstants.SYSTEM_DATA);

  if (data?.notification_channel_partners) {
    return data?.notification_channel_partners?.map((partner) => ({
      label: partner?.name,
      value: partner?.id,
    }));
  } else return [];
};

export const shouldWhatsappShow = (data) => {
  return data?.length >= 10;
};

export function createWhatsAppLink(phoneNumber, name) {
  // Ensure phone number starts with 91
  if (!phoneNumber.startsWith("91")) {
    phoneNumber = "91" + phoneNumber;
  }
  return `https://wa.me/${phoneNumber}?text=Dear Patient, ${encodeURIComponent(name)}\n\n`;
}

export const getRegularNonRegularOptions = () => {
  return [
    { label: "Regular", value: "REGULAR" },
    { label: "Non-Regular", value: "NON_REGULAR" },
  ];
};

export const isHospitalAdmin = () => {
  const role = getLocalData(storageConstants.USER_DATA)?.role;
  const upperRole = String(role || "").toUpperCase();
  return upperRole === appConstants.ROLES.HOSPITAL_ADMIN;
};

export const isAdmin = () => {
  const role = getLocalData(storageConstants.USER_DATA)?.role;
  const upperRole = String(role || "").toUpperCase();
  return upperRole === appConstants.ROLES.ADMIN || upperRole === appConstants.ROLES.HOSPITAL_ADMIN;
};

export const isManager = () => {
  const role = getLocalData(storageConstants.USER_DATA)?.role;
  return String(role || "").toUpperCase() === appConstants.ROLES.MANAGER;
};

export const isManagerAndAbove = () => {
  const role = getLocalData(storageConstants.USER_DATA)?.role;
  const upperRole = String(role || "").toUpperCase();
  return (
    upperRole === appConstants.ROLES.MANAGER ||
    upperRole === appConstants.ROLES.ADMIN ||
    upperRole === appConstants.ROLES.HOSPITAL_ADMIN
  );
};

export const isStaff = () => {
  const role = getLocalData(storageConstants.USER_DATA)?.role;
  return String(role || "").toUpperCase() === appConstants.ROLES.STAFF;
};
export const isTherapist = () => {
  const role = getLocalData(storageConstants.USER_DATA)?.role;
  return String(role || "").toUpperCase() === appConstants.ROLES.THERAPIST;
};
export const isDoctor = () => {
  const role = getLocalData(storageConstants.USER_DATA)?.role;
  return String(role || "").toUpperCase() === appConstants.ROLES.DOCTOR;
};

export const isDoctorAssistant = () => {
  const role = getLocalData(storageConstants.USER_DATA)?.role;
  return String(role || "").toUpperCase() === appConstants.ROLES.DOCTOR_ASSISTANT;
};

export const isPharmacist = () => {
  const role = getLocalData(storageConstants.USER_DATA)?.role;
  return String(role || "").toUpperCase() === appConstants.ROLES.PHARMACIST;
};

export const isCounsellor = () => {
  const role = getLocalData(storageConstants.USER_DATA)?.role;
  return String(role || "").toUpperCase() === appConstants.ROLES.COUNSELLOR;
};

export const isReceptionist = () => {
  const role = getLocalData(storageConstants.USER_DATA)?.role;
  return String(role || "").toUpperCase() === appConstants.ROLES.RECEPTION;
};
export const handleImageError = (event) => {
  // const logo = getLocalData(storageConstants.HOSPITAL_DATA)?.logo;
  // if (logo !== null) {
  //   event.target.src = logo; // Set fallback image (hospital logo)
  // } else {
  event.target.src = "/BharatOPDLogo512.png"; // Set fallback image to BharatOPD logo
  // }
  event.target.onerror = null; // Prevent infinite loops
};

export const getHospitalUnit = () => {
  const data = getLocalData(storageConstants.HOSPITAL_DATA);

  if (data?.hospital_units) {
    return data?.hospital_units?.map((hospital_units) => ({
      label: hospital_units?.name,
      value: hospital_units?.id,
    }));
  } else return [];
};

// Prescription can viewed by the role who can edit medicines, i.e, pharmacy and receptionist
export const canViewPrescription = (_data) => {
  return canAccessModule(appConstants.MODULES.VIEW_PRECRIPTION);
};

export const canEditPrescription = (status) => {
  return status?.toString().trim() !== appConstants.COMPLETED;
  // return ((status?.toString().trim() === appConstants.AT_DOCTOR || status?.toString().trim() === appConstants.AT_PHARMACY) && isDoctor())
  //     || isAdmin();
};
export const isComplete = (status) => {
  return status?.toString().trim() === appConstants.COMPLETED;
};
export const canEditMedicine = (data) => {
  let status = data?.status;
  let visitDate = data?.visit_date;

  if (isAdmin() || isHospitalAdmin() || isManager()) {
    return true;
  } else if (isTodayDate(visitDate)) {
    return true;
  } else if (isComplete(status)) {
    return false;
  }
  return true;
};

export const canViewPDF = (status) => {
  return (
    status?.toString().trim() === appConstants.AT_PHARMACY ||
    status?.toString().trim() === appConstants.COMPLETED ||
    isAdmin()
  );
};
export const isValidDate = (dateString) => {
  const date = new Date(dateString);
  return date instanceof Date && !isNaN(date);
};

export const getAmountCalculatedForMedicineOrder = (medicineData) => {
  let totalUnits = 0;
  let subTotalAmount = 0; // High precision float
  let totalCgst = 0; // High precision float
  let totalSgst = 0; // High precision float
  let totalIgst = 0; // High precision float
  let fee = parseFloat(medicineData?.fee || 0);
  let discountType = medicineData?.discountType || "FLAT";
  let discountValue = parseFloat(medicineData?.discountValue || 0);

  // Determine Tax Mode (INTRA vs INTER)
  const hospState = medicineData?.hospState?.toLowerCase()?.trim();
  const patState = medicineData?.patState?.toLowerCase()?.trim();
  const taxMode = hospState && patState && hospState !== patState ? "INTER" : "INTRA";

  // Combine all items for calculation
  const medicineItems = medicineData?.arr || [];
  const serviceItems = medicineData?.serviceArr || [];
  const customItems = medicineData?.customArr || [];
  let medicineSubTotal = 0;
  let serviceSubTotal = 0;
  let customSubTotal = 0;

  const processItem = (item, category) => {
    if (!item) return;

    const qty = parseFloat(item.qty || 0);
    const unitPrice = parseFloat(item.unit_price || 0);
    const lineTotal = qty * unitPrice; // Keep as raw float for precision
    totalUnits += qty;

    // Handle GST if present
    const configs = getLocalData(CONFIG);
    const taxType = Array.isArray(configs)
      ? configs.find((c) => c.key === CONFIGS.TAX_TYPE)?.value || "Registered"
      : "Registered";

    let itemCgst = 0;
    let itemSgst = 0;
    let itemIgst = 0;
    let itemSubtotal = lineTotal;

    const itemGstType = item.gstType || (item.medicineId ? "INCLUSIVE" : null);
    const totalRate = parseFloat(item.cgst || 0) + parseFloat(item.sgst || 0);

    if (itemGstType && taxType?.toUpperCase() === "REGISTERED") {
      const isInclusive = itemGstType === "INCLUSIVE";
      const totalItemTax = isInclusive
        ? lineTotal - lineTotal / (1 + totalRate / 100)
        : lineTotal * (totalRate / 100);

      if (taxMode === "INTER") {
        itemIgst = totalItemTax;
      } else {
        itemCgst = totalItemTax / 2;
        itemSgst = totalItemTax / 2;
      }

      itemSubtotal = isInclusive ? lineTotal - totalItemTax : lineTotal;
    }

    totalCgst += itemCgst;
    totalSgst += itemSgst;
    totalIgst += itemIgst;
    subTotalAmount += itemSubtotal;

    if (category === "medicine") medicineSubTotal += itemSubtotal;
    else if (category === "service") serviceSubTotal += itemSubtotal;
    else if (category === "custom") customSubTotal += itemSubtotal;
  };

  medicineItems.forEach((item) => processItem(item, "medicine"));
  serviceItems.forEach((item) => processItem(item, "service"));
  customItems.forEach((item) => processItem(item, "custom"));

  const totalTax = totalCgst + totalSgst + totalIgst;
  const taxableValue = subTotalAmount + fee;
  let inclusiveTotal = taxableValue + totalTax;

  // IPD bed charges
  const ipdDetail = medicineData?.ipdDetailsData;
  if (ipdDetail?.ipd_details?.bed_charges) {
    inclusiveTotal += parseFloat(ipdDetail.ipd_details.bed_charges);
  }

  // Calculate discount
  let discount = 0;
  if (discountValue > 0) {
    if (discountType === "FLAT") {
      discount = inclusiveTotal > 0 ? Math.min(discountValue, inclusiveTotal) : 0;
    } else {
      discount = (inclusiveTotal * discountValue) / 100;
    }
  }

  const grandTotal = inclusiveTotal - discount;

  return {
    totalUnits,
    total: inclusiveTotal,
    tax: totalTax,
    totalCgst: totalCgst,
    totalSgst: totalSgst,
    totalIgst: totalIgst,
    discount: discount,
    subTotal: taxableValue,
    medicineSubTotal: medicineSubTotal,
    serviceSubTotal: serviceSubTotal,
    customSubTotal: customSubTotal,
    grandTotal: grandTotal,
    fee: fee,
    discountType,
    discountValue,
    round_off: medicineData?.round_off || "0.00",
    taxMode,
  };
};

export const canAccessPage = (pageName) => {
  if (Object.values(appConstants.PAGES).includes(pageName)) {
    const r = getLocalData(storageConstants.USER_DATA)?.role;

    const {
      ADMIN,
      DOCTOR,
      DOCTOR_ASSISTANT,
      PHARMACIST,
      COUNSELLOR,
      RECEPTION,
      MANAGER,
      HOSPITAL_ADMIN,
      THERAPIST,
      STAFF,
    } = appConstants.ROLES;
    const {
      DASHBOARD,
      PATIENTS,
      PATIENT_VISIT,
      PATIENT_VISIT_V2,
      HELP,
      SALE_RETURN,
      MEDICINES,
      PURCHASE_MEDICINES,
      CHANGE_PASSWORD,
      DEPARTMENTS,
      SUPPLIERS,
      SERVICES,
      MEDICINE_TYPES,
      MEDICINE_CATEGORY,
      INVENTORY_CATEGORY,
      SERVICE_TYPES,
      REPORTS,
      USERS,
      EXPORT,
      ATTENDANCE,
      EXPENSE_CATEGORY,
      EXPENSE,
      ROOMS,
      BEDS,
      IPD_MANAGEMENT,
      EDIT_IPD_MANAGEMENT,
      ALERT,
      CALENDAR,
      NEXT_VISIT,
      WHATSAPP_SCHEDULE,
      ADD_WHATSAPP_SCHEDULE,
      ADD_WHATSAPP_TEMPLATE,
      TEMPLATE,
      SMS_SCHEDULE,
      ADD_SMS_SCHEDULE,
      ADD_SMS_TEMPLATE,
      SMS_TEMPLATE,
      PATIENT_LISTING,
      DIAGNOSIS,
      PATIENT_DETAILS,
      APPLICATIONS,
      BEFORE_AFTER,
      MEDICINE_BILL,
      CREDIT_NOTES,
      TREATMENT,
      TRACK_PATIENT,
      ADD_PATIENT,
      INVENTORY,
      WHATSAPPINBOX,
      DLT_CONFIG,
      CUSTOM_BILLING_ITEMS,
      PAYMENT_TRACKER,
      EXPIRY_TRACKER,
      WALLET,
      MEDICINE_AUDIT,
    } = appConstants.PAGES;

    const commonAccess =
      pageName === IPD_MANAGEMENT ||
      pageName === EDIT_IPD_MANAGEMENT ||
      pageName === DASHBOARD ||
      pageName === PATIENTS ||
      pageName === CALENDAR ||
      pageName === PATIENT_VISIT ||
      pageName === PATIENT_VISIT_V2 ||
      pageName === PATIENT_DETAILS ||
      pageName === NEXT_VISIT ||
      pageName === HELP ||
      pageName === CHANGE_PASSWORD ||
      pageName === EXPENSE ||
      pageName === PATIENT_LISTING ||
      pageName === DIAGNOSIS ||
      pageName === BEFORE_AFTER ||
      pageName === MEDICINE_BILL ||
      pageName === CREDIT_NOTES ||
      pageName === TREATMENT ||
      pageName === TRACK_PATIENT ||
      pageName === ADD_PATIENT ||
      pageName === APPLICATIONS ||
      pageName === INVENTORY ||
      pageName === WHATSAPPINBOX;

    const therapistAccess = pageName === DASHBOARD || pageName === HELP || pageName === INVENTORY;

    const staffAccess = pageName === DASHBOARD || pageName === HELP || pageName === INVENTORY;

    const dataManagementAccess =
      pageName === DEPARTMENTS ||
      pageName === SERVICE_TYPES ||
      pageName === CUSTOM_BILLING_ITEMS ||
      pageName === MEDICINE_TYPES ||
      pageName === MEDICINE_CATEGORY ||
      pageName === INVENTORY_CATEGORY ||
      pageName === SUPPLIERS ||
      pageName === EXPENSE_CATEGORY ||
      pageName === EXPENSE ||
      pageName === APPLICATIONS;

    const extraAccess =
      pageName === SALE_RETURN || pageName === MEDICINES || pageName === PURCHASE_MEDICINES;

    const adminAccess =
      commonAccess ||
      pageName === SERVICES ||
      extraAccess ||
      pageName === MEDICINE_AUDIT ||
      dataManagementAccess ||
      pageName === REPORTS ||
      pageName === USERS ||
      pageName === ATTENDANCE ||
      pageName === EXPENSE_CATEGORY ||
      pageName === EXPENSE ||
      pageName === ROOMS ||
      pageName === BEDS ||
      pageName === ALERT ||
      pageName === WHATSAPP_SCHEDULE ||
      pageName === ADD_WHATSAPP_SCHEDULE ||
      pageName === DLT_CONFIG ||
      pageName === ADD_WHATSAPP_TEMPLATE ||
      pageName === TEMPLATE ||
      pageName === SMS_SCHEDULE ||
      pageName === ADD_SMS_SCHEDULE ||
      pageName === ADD_SMS_TEMPLATE ||
      pageName === SMS_TEMPLATE ||
      pageName === PAYMENT_TRACKER ||
      pageName === WALLET ||
      pageName === EXPIRY_TRACKER;

    const hospitalAdminAccess = adminAccess || pageName === EXPORT;

    const managerAccess =
      commonAccess ||
      pageName === ROOMS ||
      pageName === BEDS ||
      pageName === ALERT ||
      pageName === EDIT_IPD_MANAGEMENT ||
      extraAccess ||
      pageName === MEDICINE_AUDIT ||
      pageName === SERVICES ||
      pageName === EXPENSE_CATEGORY ||
      pageName === EXPENSE ||
      pageName === WHATSAPP_SCHEDULE ||
      pageName === ADD_WHATSAPP_SCHEDULE ||
      pageName === DLT_CONFIG ||
      pageName === ADD_WHATSAPP_TEMPLATE ||
      pageName === TEMPLATE ||
      pageName === SMS_SCHEDULE ||
      pageName === ADD_SMS_SCHEDULE ||
      pageName === ADD_SMS_TEMPLATE ||
      pageName === SMS_TEMPLATE ||
      pageName === DEPARTMENTS ||
      pageName === SUPPLIERS ||
      pageName === MEDICINE_TYPES ||
      pageName === MEDICINE_CATEGORY ||
      pageName === INVENTORY_CATEGORY ||
      pageName === SERVICE_TYPES ||
      pageName === PAYMENT_TRACKER ||
      pageName === EXPIRY_TRACKER;
    const pharmacistAccess =
      commonAccess ||
      pageName === EDIT_IPD_MANAGEMENT ||
      extraAccess ||
      pageName === EXPENSE_CATEGORY ||
      pageName === EXPENSE ||
      pageName === ADD_WHATSAPP_SCHEDULE ||
      pageName === DLT_CONFIG ||
      pageName === ADD_WHATSAPP_TEMPLATE ||
      pageName === ADD_SMS_SCHEDULE ||
      pageName === ADD_SMS_TEMPLATE ||
      pageName === TEMPLATE ||
      pageName === SMS_TEMPLATE ||
      pageName === SMS_SCHEDULE ||
      pageName === EXPIRY_TRACKER;
    const receptionAccess = commonAccess || pageName === SALE_RETURN;

    const upperRole = String(r || "").toUpperCase();

    if (upperRole === HOSPITAL_ADMIN) {
      return hospitalAdminAccess;
    } else if (upperRole === ADMIN) {
      return adminAccess;
    } else if (upperRole === MANAGER) {
      return managerAccess || pageName === ATTENDANCE;
    } else if (upperRole === PHARMACIST) {
      return pharmacistAccess;
    } else if (upperRole === THERAPIST) {
      return therapistAccess;
    } else if (upperRole === STAFF) {
      return staffAccess;
    } else if (upperRole === RECEPTION || upperRole === COUNSELLOR) {
      return receptionAccess;
    } else if (
      upperRole === DOCTOR ||
      upperRole === DOCTOR_ASSISTANT ||
      upperRole === RECEPTION ||
      upperRole === COUNSELLOR ||
      upperRole === STAFF
    ) {
      return commonAccess;
    } else return false;
  }
};
/** Aligns DB/API values with ORDER | VISIT (legacy admin saved wrong strings). */
export const normalizeBillGenerateValue = (raw) => {
  if (raw == null || raw === "") return "ORDER";
  const s = String(raw).trim();
  if (s.toUpperCase() === "VISIT") return "VISIT";
  if (s.toUpperCase() === "ORDER") return "ORDER";
  if (s === "When Order Created") return "VISIT";
  if (s === "When Order Paid") return "ORDER";
  if (s.toLowerCase().includes("visit")) return "VISIT";
  return "ORDER";
};

export const shouldShowHospitalUnit = (pageName) => {
  const configs = getLocalData(storageConstants.CONFIG);
  const hospital = getLocalData(storageConstants.HOSPITAL_DATA);
  const hospitalUnit = hospital?.hospital_units;

  if (!Array.isArray(configs)) {
    return false;
  }

  const raw = configs.find((i) => i.key === appConstants.CONFIGS.BILL_GENERATE)?.value;
  const bill_generate = normalizeBillGenerateValue(raw);

  let show = true;
  if (!hospitalUnit || hospitalUnit.length <= 1) {
    show = false;
  } else if (pageName === appConstants.PAGES.MEDICINE_MODAL && bill_generate === "ORDER") {
    show = true;
  } else if (
    pageName === appConstants.PAGES.PATIENT_DETAILS ||
    pageName === appConstants.PAGES.PATIENT_VISIT_V2
  ) {
    // Both VISIT and ORDER billing modes must prompt unrestricted admin to pick the unit on visit creation
    show = true;
  } else {
    show = false;
  }

  return show;
};

export const getDefaultLandingRoute = () => {
  // 1. Role-specific overrides: Staff or Therapist always land on Dashboard
  if (isTherapist() || isStaff()) {
    return appConstants.PAGES.DASHBOARD;
  }

  // 2. Fetch hospital configs
  const config = getLocalData(storageConstants.CONFIG);
  const landingConfig = Array.isArray(config)
    ? config.find((c) => c?.key === appConstants.CONFIGS.DEFAULT_LANDING_VIEW)
    : null;
  const landingView = (landingConfig?.value || "VISIT").toUpperCase();

  // 3. Calendar View: Check if configured as landing view OR legacy mandatory calendar
  const [isCalendarShow, isCalendarMandatory] = isConfigEnable(appConstants.CONFIGS.CALENDAR_VIEW);
  const isCalendarTargeted = landingView === "CALENDAR" || (isCalendarMandatory && isCalendarShow);

  if (isCalendarTargeted && isCalendarShow && canAccessPage(appConstants.PAGES.CALENDAR)) {
    return appConstants.PAGES.CALENDAR;
  }

  // 4. Patient(s) Master List: /patient-list
  if (landingView === "PATIENT") {
    if (canAccessModule(MODULES.PATIENT_LISTING)) {
      return appConstants.PAGES.PATIENT_LISTING;
    }
    // Fallbacks if user lacks access to Patient Master
    if (canAccessPage(appConstants.PAGES.PATIENTS)) {
      return appConstants.PAGES.PATIENTS;
    }
    return appConstants.PAGES.DASHBOARD;
  }

  // 5. Dashboard: /dashboard
  if (landingView === "DASHBOARD") {
    if (canAccessModule(MODULES.DASHBOARD_MODULE)) {
      return appConstants.PAGES.DASHBOARD;
    }
    if (canAccessPage(appConstants.PAGES.PATIENTS)) {
      return appConstants.PAGES.PATIENTS;
    }
    if (canAccessModule(MODULES.PATIENT_LISTING)) {
      return appConstants.PAGES.PATIENT_LISTING;
    }
    return appConstants.PAGES.DASHBOARD;
  }

  // 6. Default: Patient Visit(s) (/patients)
  if (canAccessPage(appConstants.PAGES.PATIENTS)) {
    return appConstants.PAGES.PATIENTS;
  }
  if (canAccessModule(MODULES.PATIENT_LISTING)) {
    return appConstants.PAGES.PATIENT_LISTING;
  }
  return appConstants.PAGES.DASHBOARD;
};

export const isConfigEnable = (key) => {
  const config = getLocalData(storageConstants.CONFIG);
  if (!Array.isArray(config)) return [false, false, null];
  const foundConfig = config?.find((c) => c?.key === key);
  return [foundConfig?.show === "true", foundConfig?.mandatory === "true", foundConfig?.value];
};

export const isHideDigitalHeaderEnabled = () => {
  const config = getLocalData(storageConstants.CONFIG);
  if (!Array.isArray(config)) return false;
  const foundConfig = config?.find((c) => c?.key === "request_hide_header_foooter");
  return foundConfig?.value === "true";
};

export const shouldDueShow = () => {
  const config = getLocalData(storageConstants.CONFIG);
  if (!Array.isArray(config)) return false;
  let Obj = config?.find((i) => i.key === appConstants.CONFIGS.SHOW_DUES);

  return Obj?.value === appConstants.YES || Obj?.value === "true";
};

export const shouldVitals = () => {
  const config = getLocalData(storageConstants.CONFIG);
  if (!Array.isArray(config)) return false;
  let Obj = config?.find((i) => i.key === appConstants.CONFIGS.SHOW_VITALS);
  return Obj?.value === appConstants.YES || Obj?.value === "true";
};
export const isAddServiceOnVisit = () => {
  const config = getLocalData(storageConstants.CONFIG);
  if (!Array.isArray(config)) return false;
  let Obj = config?.find((i) => i.key === "add_services_on_visit");
  return Obj?.value === appConstants.YES || Obj?.value === "true";
};

export const isDropdownConfigEnable = (key) => {
  if (key?.label === "prescription_dose_option_dropdown") {
    const config = getLocalData(storageConstants.CONFIG);
    if (!Array.isArray(config)) return false;
    let isAllowed = config && config?.find((i) => i?.key === key?.label)?.value === key?.value;
    return isAllowed;
  }
};
export const getFollowupDate = (followup) => {
  const unit = followup.slice(-1);
  const amount = parseInt(followup.slice(0, -1));

  let futureDate;
  if (unit === "D") {
    futureDate = moment().add(amount, "days");
  } else if (unit === "W") {
    futureDate = moment().add(amount, "weeks");
  } else if (unit === "M") {
    futureDate = moment().add(amount, "months");
  } else {
    return "Invalid followup format";
  }

  return futureDate.format("Do MMMM YYYY");
};
export const ageInFormatDisplay = (date, format = "yrs") => {
  if (!date || date === "-") return "-";

  const currentDate = new Date();
  const birthDate = new Date(date);

  if (isNaN(birthDate.getTime())) return "-";

  const diffInMilliseconds = currentDate - birthDate;
  const years = currentDate.getFullYear() - birthDate.getFullYear();
  const months = currentDate.getMonth() - birthDate.getMonth();
  const days = currentDate.getDate() - birthDate.getDate();

  let adjustedYears = years;
  let adjustedMonths = months;
  let adjustedDays = days;

  if (adjustedDays < 0) {
    adjustedMonths--;
    adjustedDays += new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
  }

  if (adjustedMonths < 0) {
    adjustedYears--;
    adjustedMonths += 12;
  }

  // Auto-switch logic for format based on age
  if (adjustedYears === 0 && format === "yrs") {
    format = "mon";
  }

  if (adjustedMonths === 0 && adjustedYears === 0 && format === "mon") {
    format = "days";
  }

  switch (format) {
    case "mon":
      if (adjustedYears <= 0) {
        return `${adjustedMonths} M${adjustedMonths !== 1 ? "" : ""}`;
      }
      return `${adjustedYears * 12 + adjustedMonths} M${adjustedYears * 12 + adjustedMonths !== 1 ? "" : ""}`;
    case "days":
      return `${Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24))} D${Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24)) !== 1 ? "" : ""}`;
    case "yrs":
    default:
      return `${adjustedYears} Y${adjustedYears !== 1 ? "" : ""}`;
  }
};
export const getTreatment = () => {
  const systemData = getLocalData(storageConstants.SYSTEM_DATA);

  if (systemData?.treatments && Array.isArray(systemData.treatments)) {
    return systemData.treatments.map((item) => ({
      id: item.id,
      name: item.name,
      session: item.default_qty || 0,
      status: item.status,
    }));
  }
};

export const getTreatmentOptions = () => {
  return getTreatment()?.map((t) => ({
    value: t.id,
    label: t.name,
    session: t.session,
    status: t.status,
  }));
};
export const getTreatmentName = (id) => {
  const treatments = getTreatment(); // or use getTreatmentOptions() if using dropdown format

  if (id && treatments?.length > 0) {
    const match = treatments.find((t) => parseInt(t.id) === parseInt(id));
    return match?.name || "";
  }

  return "";
};
export const getTreatmentDetails = (id) => {
  const data = getTreatmentOptions();
  if (id && data) {
    const result = data?.find((t) => t.value === parseInt(id));
    return result || {};
  } else {
    return {};
  }
};

export const saveToLocalStorage = (text, key) => {
  if (isNullOrEmpty(text)) {
    return;
  }
  let storedData = JSON.parse(localStorage.getItem(key)) || [];

  const index = storedData.findIndex(
    (item) => item.text !== null && item.text.toLowerCase() === text.toLowerCase(),
  );

  if (index !== -1) {
    storedData[index].last_used = new Date().toISOString();
    storedData[index].text = text;
  } else {
    storedData.push({
      text,
      last_used: new Date().toISOString(),
    });
  }

  localStorage.setItem(key, JSON.stringify(storedData));
  cleanOldData(key);
};

export const cleanOldData = (key) => {
  const data = JSON.parse(localStorage.getItem(key)) || [];

  const now = Date.now();
  const days30 = 30 * 24 * 60 * 60 * 1000; // 30 days in ms

  const freshData = data.filter((item) => {
    const lastUsed = new Date(item.last_used).getTime();
    return now - lastUsed <= days30; // keep only recent ones
  });

  localStorage.setItem("myData", JSON.stringify(freshData));
  return freshData; // return cleaned data if you need it
};

/**
 * Validate a UPI ID string.
 * @param {string} upiId - e.g. "rahul.sharma@okhdfcbank" or "9876543210@upi"
 * @param {Object} [opts]
 * @param {boolean} [opts.useAllowList=false] - If true, enforce PSP suffix allow-list.
 * @returns {{ valid: boolean, reason?: string, parts?: { handle: string, psp: string } }}
 */
export function validateUpiId(upiId, opts = {}) {
  if (typeof upiId !== "string") {
    return { valid: false, reason: "UPI ID must be a string." };
  }

  // normalize: trim and lowercase (UPI is effectively case-insensitive)
  const normalized = upiId.trim().toLowerCase();

  // must have exactly one "@"
  const atCount = (normalized.match(/@/g) || []).length;
  if (atCount !== 1) {
    return {
      valid: false,
      reason: 'UPI ID must contain exactly one "@" symbol.',
    };
  }

  const [handle, psp] = normalized.split("@");

  // basic sanity checks
  if (!handle || !psp) {
    return { valid: false, reason: "Missing handle or PSP part." };
  }

  // Handle (username) rules:
  // - 2–50 chars
  // - letters, digits, dot, underscore, hyphen
  const handleRe = /^[a-z0-9._-]{2,50}$/i;
  if (!handleRe.test(handle)) {
    return {
      valid: false,
      reason: 'Handle must be 2–50 chars: letters, digits, ".", "_", "-".',
    };
  }

  // PSP (bank/PSP) rules:
  // - 2–30 letters (some providers are all letters, e.g. okhdfcbank, oksbi, upi, paytm)
  // If you encounter digits in PSP in your data, relax this to /^[a-z0-9-]{2,30}$/.
  const pspRe = /^[a-z]{2,30}$/i;
  if (!pspRe.test(psp)) {
    return {
      valid: false,
      reason: "PSP must be 2–30 letters (e.g., okhdfcbank, oksbi, upi).",
    };
  }

  if (opts.useAllowList) {
    // A concise allow-list of common PSP suffixes. Add/edit to match your needs.
    const allowedPsps = new Set([
      "upi",
      "oksbi",
      "okaxis",
      "okicici",
      "okhdfcbank",
      "okkotak",
      "okyesbank",
      "okidbi",
      "oksbipay",
      "paytm",
      "ibl",
      "axl",
      "ybl",
      "apl",
      "sbi",
      "hdfcbank",
      "axisbank",
      "kotak",
      "barodampay",
      "fbl",
      "idfcbank",
      "mahb",
      "pnb",
      "okbizaxis",
    ]);
    if (!allowedPsps.has(psp)) {
      return {
        valid: false,
        reason: `Unrecognized PSP suffix "${psp}" (useAllowList on).`,
      };
    }
  }

  return { valid: true, parts: { handle, psp } };
}
